export default [
  {
    id: "001",
    title: "概要",
    children: [
      {
        id: "001001",
        title: "",
        content: `
深圳得理科技有限公司成立于2018年，是一家由国内顶级法律团队和 AI 团队联合发起的法律科技公司，并于2019年联手中科院深圳先进院成立法律人工智能实验室，专注法律行业AI模型算法研究。

其自研的得理法律大模型达到业内领先水平，以得理法律大模型为基础，得理科技还研发了得理律助和得理法搜两条主要产品线，以小理AI和小理智能体为核心组件，为法律人、企业及个人提供一揽子法律+AI解决方案。

您可以依据以下产品功能差异选择适合您使用的产品。

<table class="custom-table">
    <tr bgcolor="#C5DFB4">
        <td>产品</td>
        <td>小理AI</td>
        <td>得理法搜</td>
        <td>得理律助</td>
    </tr>
    <tr>
        <td rowspan="6">功能</td>
        <td>法律咨询</td>
        <td>专业法律检索</td>
        <td>案源拓展</td>
    </tr>
    <tr>
        <td>法律研究</td>
        <td>AI阅读裁判文书</td>
        <td>得理法搜</td>
    </tr>
    <tr>
        <td>文本生成</td>
        <td>文本智能生成</td>
        <td>智慧办公</td>
    </tr>
    <tr>
        <td>案件分析</td>
        <td>AI法律研究</td>
        <td>文档管理</td>
    </tr>
    <tr>
        <td>文案创作</td>
        <td>AI+律师法律咨询</td>
        <td>小理AI</td>
    </tr>
    <tr>
        <td>律师智能推荐</td>
        <td>法律资讯推荐</td>
        <td>小理智能体</td>
    </tr>
    <tr>
        <td>适合用户</td>
        <td>法律从业者 / 企业 / 个人</td>
        <td>法律从业者 / 企业 / 个人</td>
        <td>法律团队/律所/独立律师</td>
    </tr>
</table>
        `,
      },
      {
        id: "001002",
        title: "得理科技产品具有哪些优势？",
        content: `
以“AI+律师”为基础的解决方案，融合大模型、智能检索技术，简化法律检索，为法律工作者提升效率赋能。一站式的平台设计，打通案源和商机。最全、最新的全域法律数据库，最简洁轻便的交互设计，让工作更轻松。
        `,
      },
      {
        id: "001003",
        title: "购买得理产品的订单可以开发票吗？",
        content: `
可以的，付费后可以从“我的”->“订单及续费管理”看到付费的订单，并点击该订单的“开发票”就可以提交开票申请，得理财务人员收到请求后通常在3个工作日内开出电子发票并短信通知用户，用户可以在订单处查看并下载电子发票。
        `,
      },
      {
        id: "001004",
        title: "什么是邀请码，如何获取邀请码？",
        content: `
邀请码是得理科技在开展一些不定期活动（比如买就送，加企微送免费体验等福利）时提供给到用户的一个活动邀请数字序列（4位数字），用户在“我的”->“会员邀请码”，输入客服给到的邀请码，就可以延长免费使用的期限。详情请添加得理科技企业微信客服了解。
        `,
      },
      {
        id: "001005",
        title: "得理科技如何保障数据的安全性？",
        content: `
首先是存储安全性，我们采用阿里云存储服务，其内在的异地灾备和多线机制能确保数据的存放安全。

其次是高可用性，我们采用了容器化的可伸缩架构，通过技术手段使平台在高并发时仍然能够提供服务而不会超时或拥堵。

另外是数据保密性，我们对敏感信息采取了加密存储和传输，确保敏感数据安全，同时我们坚持贯彻按ISO27001信息安全管理体系开展研发工作，提升信息安全的管理级别。
        `,
      },
    ],
  },
  {
    id: "002",
    title: "得理法律大模型",
    children: [
      {
        id: "002001",
        title: "得理法律大模型是什么？",
        content: `
AI大模型指的是使用深度学习技术构建的规模庞大的神经网络模型。这些模型具有数以亿计的参数，能够对大量的数据进行训练，从而在各种任务和领域中展现出强大的语言理解、生成和推理能力。通过在大规模的数据集上进行预训练，使其具备了广泛的语言知识和理解能力。通过在特定任务上的指令微调，以适应具体的应用需求。它们通常能够自动从输入数据中提取特征、学习语义关系，并生成具有逻辑和上下文连贯性的输出。从而在自然语言处理、对话系统、机器翻译、摘要生成、问题解答、文本分类等应用领域为用户提供了强大的语言交互和智能化的服务。

得理法律大模型在通用大模型的基础上进行了持续预训练、有监督微调、基于人类反馈的强化学习，并在上述阶段引入法律领域特定知识，因此得理法律大模型能够生成更加专业和准确的回答。
      `,
      },
      {
        id: "002002",
        title: "得理法律大模型能帮助您做什么？",
        content: `
得理法律大模型在法律领域应用十分广泛，首先在文本检索领域，得理法律大模型能够将用户输入的关键字进行语义理解和意图识别，从而将离散的词转为句子进行问题推荐，并对用户的问题直接生成回答，改变了传统检索方式将问题中的关键词提炼出来再进行关键字检索耗时耗力且专业性要求很强的情况，允许直接用自然语言文本进行检索，从而大大提升了检索效率和精度。

其次在文本生成方面，得理法律大模型可以依据用户输入的要求，自动生成合同模板、起诉书等，并可用不同的提示词技巧来满足格式化文本的要求。

在长文本阅读方面，得理法律大模型的总结归纳能力十分优秀，大大缩短了用户阅读长篇的裁判文书、合同等文本的时间。
        `,
      },
      {
        id: "002003",
        title: "得理法律大模型应用到了哪些产品中？",
        content: `
得理法律大模型深入应用到了得理的所有产品中，应用场景包括：智能咨询、智能摘要、文本生成、意图识别、检索增强等。
        `,
      },
      {
        id: "002004",
        title: "如何使用得理法律大模型的工具指令集简化提问和提升精准度？",
        content: `
大模型的指令集主要包括：理解和生成法律文本、检索和总结法律信息、做出基于法律规定的预测或推荐、辅助撰写法律文书以及进行法律咨询等。

首先，理解和生成法律文本是大模型在法律领域的基础功能。这意味着AI需要理解各种法律术语及其含义，并且能够生成符合法律语言规范的文本。例如，用户可以向AI提出“解释著作权法的基本概念”的请求，AI则能生成一段清晰、准确的解释。

其次，通过AI技术，检索和总结法律信息可以更有效率。在诸如合同审查、案例研究等任务中，AI可以快速检索相关信息，高效地从大量数据中抽取核心内容和重要信息，有效节约了传统手动查找的时间和金钱成本。

再次，基于法律规定进行预测或推荐也是大模型的重要功能之一。例如，在判决预测中，大模型可以通过分析过去的案例，预测特定案例可能的判决结果，为法律顾问和当事人提供参考。

同时，基于客户的需求和情况，AI也可以提供合适的法令和规章的推荐。

此外，大模型还可以辅助用户撰写法律文书。借助AI的自然语言生成能力，大模型可以将用户提供的信息转化为具有法律效力的文书，如起诉状、答辩状、合同、遗嘱等，实现高效且准确的文书生成。
        `,
      },
    ],
  },
  {
    id: "003",
    title: "小理AI",
    children: [
      {
        id: "003001",
        title: "小理AI是什么？",
        content: `小理AI是得理科技研发的得理法律大模型，小理AI能够基于自然语言与人对话，具备法律咨询、法律检索、法律研究、案件分析、文本撰写、律师智推等功能。`,
      },
      {
        id: "003002",
        title: "小理AI有哪些功能？",
        content:`
<h2>功能一：法律分析</h2>

小理AI能够针对复杂的法律条款、案例及司法解释进行深度理解和解答，相比于通用大模型，它具有更强的法律情境感知能力和法规适应性，克服了通用大模型在生成法条时的幻觉问题，能够为用户在案件准备、策略制定阶段提供针对性极强的法律意见和参考依据。

<h2>功能二：法律研究</h2>

小理AI显著提升法律研究效率，通过整合海量法律数据、案例和法规、外网观点，迅速为用户提供法律信息和建议。在起草法律文件时，它能根据案件情况自动生成严谨、专业的文本，确保内容准确合法，大幅节省律师的时间和精力。同时，小理AI具备强大的数据分析能力，深入探究法律条文和案例，帮助用户理解法律适用范围，为案件胜诉提供有力支持。

<h2>功能三：法律检索</h2>

小理AI它不仅可以对海量的法条、法规、案例进行高效的检索，而且支持模糊检索、精准检索以及语义检索等多种方式。这种全面的检索功能极大地提升了律师的工作效率。无论是想要快速定位某一特定的法律条文，还是希望深入理解某一法律案例的判决逻辑，小理AI都能迅速、准确地为用户提供所需的信息。

<h2>功能四：文档分析</h2>

小理AI能对上传的法律文书、判决文书等长文本进行深度分析，提取关键信息点，挖掘潜在关联，帮助用户梳理案情脉络，预测判案趋势。其专业级的文本分析能力远超一般大模型，能够精准提炼法律要点，助力用户在案件研究和法庭辩论中占据先机。

<h2>功能五：法律文书</h2>

小理AI可以协助用户快速起草各类法律文件，如起诉状、答辩状、法律意见书等，确保内容准确无误且符合法律规定。通过吸收并整合大量的法律范本和成功案例，小理AI能够根据具体案件情况，自动输出结构严谨、用词专业的法律文本，极大地提高了用户的工作效率。

<h2>功能六：合同生成</h2>

小理AI可快速生成各类合同文件，如买卖合同、租赁合同、劳动合同、服务协议等。小理通过学习海量法律文书和合同模板，当用户输入合同的基本信息、条款要求及特定需求时，小理能够迅速理解并分析这些信息，生成结构清晰、逻辑严密、用词精确且符合行业习惯与法律规定的合同草案。

<h2>功能七：合同审查</h2>

小理AI可快速且精准地审查各类合同文件，包括买卖合同、租赁合同等，通过海量法律数据与案例的学习，智能识别合同中的潜在风险与不合规条款，为用户提供高效、全面的合同审查解决方案。

<h2>功能八：文本创作</h2>

大模型文本创作技术运用深度学习的先进成果，能够自动分析并理解用户输入的创意、主题或故事情节，结合海量的文本数据与文学风格，创作出结构丰富、情节连贯、表达独特的文本作品，为创作者提供无限的灵感与高效的创作支持。

<h2>功能九：问律师</h2>

用户可以随时随地向专业律师发起咨询。无论是面对法律纠纷、合同审查、权益保护还是任何法律相关疑问，用户只需简单描述问题，即可获得来自资深律师的专业解答与建议，让法律帮助触手可及。
        `,
      },
      {
        id: "003003",
        title: "如何使用小理AI呢？",
        content: `
<h2>一分钟教你学会写指令</h2>

![image](https://delicdn.delilegal.com/dls/f96656b440bcec43803e25abf43db8da/f96656b440bcec43803e25abf43db8da.png)

一条优秀的指令可以按照“背景信息/上下文+目标/任务+具体要求/限制”这样的结构来构建。这样的指令结构不仅清晰明确，还能帮助接收者准确理解并执行指令。下面是对这几个组成部分的详细阐述：
<h2>1.目标或任务说明：</h2>

<span style="display: inline-block;text-indent:20px;">● 这是提示词的核心部分，明确指出了用户希望模型执行的具体任务或达成的目标。例如，“生成一篇关于人工智能的科普文章”。</span>

<h2>2. 上下文或背景信息：</h2>

<span style="display: inline-block;text-indent:20px;">● 虽然不是每个提示词都必须包含此部分，但在需要模型根据特定背景或情境生成内容时，提供上下文信息非常重要。这有助于模型</span>
<span style="display: inline-block;text-indent:32px;">更好地理解用户的意图，并生成更符合要求的内容。例如，“假设你是一位科普作家，面向中学生介绍人工智能的基本概念”。</span>

<h2>3. 具体要求或限制：</h2>

<span style="display: inline-block;text-indent:20px;">● 在这一部分，用户可以详细列出对模型输出的具体要求或限制条件。这包括字数限制、风格要求（如正式、幽默等）、内容要求</span>
<span style="display: inline-block;text-indent:26px;">（如包含特定事实、避免某些话题）等。例如，“文章长度不超过800字，语言通俗易懂，避免使用过多专业术语”。</span>

一条优秀的提示词通常包括目标或任务说明、上下文或背景信息（如果需要）、具体要求或限制。这样的指令结构不仅有助于提高指令的执行效率，还有助于减少误解和沟通障碍。
        `,
      },
      {
        id: "003004",
        title: "可以单独购买小理AI吗？",
        content: `目前小理AI内嵌在得理法搜和得理律助2个产品中，您付费得理法搜或者得理律助的会员，都可以使用小理AI的功能。`,
      },
      {
        id: "003005",
        title: "在小理AI上咨询律师收费吗？",
        content: `咨询律师是免费的，得理科技希望搭建一个”AI+律师“的平台，帮助用户找到合适专业的律师，平台不会向律师和用户收取任何费用，具体的案件代理费用由双方协商确定。`,
      },
      {
        id: "003006",
        title: "在小理AI上咨询律师，但是长时间没有收到回复怎么办？",
        content: `如果咨询的问题长时间没有回复，可以检查一下提的法律问题是否是真实有效？内容是否表达清晰？可修改完善后重新发起咨询。  `,
      },
    ],
  },
  {
    id: "004",
    title: "得理法搜",
    children: [
      {
        id: "004001",
        title: "谁适合使用得理法搜？",
        content: `
得理法搜是法律数据新一代智能引擎，适合法律从业者、企业、个人使用。通过智能搜索技术帮助法律工作者查案例、找法规、看观点、读法讯。
        `,
      },
      {
        id: "004002",
        title: "得理法搜有哪几种产品形态？",
        content: `
得理法搜有三种产品形态：网页版、手机App、微信小程序，用户可以通过任何一种方式随时随地访问得理法搜。
        `,
      },
      {
        id: "004003",
        title: "得理法搜有哪些功能？",
        content: `
法搜主要功能有：案例检索、法规检索、观点检索、行政处罚检索、检查文书检索、法官检索、律师检索、法律资讯、小理AI、知识产权专业库（专利和商标）、地产工程专业库。
        `,
      },
      {
        id: "004004",
        title: "得理法搜的亮点功能有哪些？",
        content: `
智能检索：通过直接输入或上传争议焦点、法律问题、案情描述等自然语言文本智能检索类案。

一键检索多维呈现：一次检索，案例、法规、观点、法讯同步输出结果，便于法律从业者全方位了解信息。

观点检索：法搜数据库包含各个法律细分领域的名家观点和分析。

智能报告：系统自动提取关键事实和裁判观点，一键生成检索报告。

时间轴：得理法律大模型自动提取案件的时间轴，将错综复杂的案情描述化繁为简，事件相关经过和时间点清晰排序，使案件发展一目了然。

检索智能回答：检索类案时，得理法律大模型自动给出类案摘要分析。

案情智能摘要：得理法律大模型从冗长的裁判文书中自动提取关键信息：诉讼请求、案情概述、争议焦点、法院认为、裁判依据、判决结果。

可视化检索结果：可视化呈现检索结果，包括：年视图、月视图、案件地域分布、案由分布、引用法条等多个指标维度。

知识产权专业库：智能检索专利、商标、域名以及知识产权相关的案例，用户可直接上传专利说明书进行查重，帮助用户在申请起草专利时规避抄袭等同类表述。

地产工程专业库：免费使用专业梳理的地产工程相关的案例、法规、观点及建纬专栏文章。

小理AI：内嵌得理法律大模型，用户通过AI也可以完成法律检索、案情分析、法律研究、法律文书生成等工作。
        `,
      },
      {
        id: "004005",
        title: "类案检索的过程是怎样的?",
        content: `
最高人民法院（以下简称最高院）印发《关于统一法律适用加强类案检索的指导意见（试行）》（以下简称《指导意见》），提出了类案检索机制的规范化、制度化要求。《指导意见》第八条对类案检索报告的构成要素作出明确规定：“类案检索报告应当客观、全面、准确，包括检索主体、时间、平台、方法、结果，类案裁判要点以及待决案件争议焦点等内容，并对是否参照或者参考类案等结果运用情况予以分析说明。”。

一份类案检索报告大致应包括封面（图2）、待决案件基本情况、检索结果基本情况、检索结果与待决案件参照适用情况、类案检索报告结论等内容。

得理法搜可一键生成类案检索报告（图1），大大简化起草报告的时间：

![image](https://delicdn.delilegal.com/dls/af6b82d14630c1c52557248ac83c6e56/af6b82d14630c1c52557248ac83c6e56.png)

<p align="center">（图1）</p>

![image](https://delicdn.delilegal.com/dls/49fc92375529154c9884df6eb07d71a0/49fc92375529154c9884df6eb07d71a0.png)

<p align="center">（图2）</p>

[附：全国语义检索大赛获奖检索报告.pdf](https://delicdn.delilegal.com/dls/7d2ac3cfc451e28237793a2aea6bb1c1/7d2ac3cfc451e28237793a2aea6bb1c1.pdf)
        `,
      },
      {
        id: "004006",
        title: "如何提升类案检索的准确度？",
        content: `
见上图2的检索内容：劳动合同、欠薪、社保，这其实是针对检索命题（没有签订劳动合同，单位也没有缴交社保，如何要回单位的欠薪？）所提取的关键字，但这样检索对于查找相关类案是有一定经验要求即对检索关键字的提取、组合的问题。得理法搜的智能检索算法无需进行关键字拆分，直接将完整问题输入就可以进行类案检索（图3），检索的结果更精准、更全面。

![image](https://delicdn.delilegal.com/dls/26c1e10c6bcf3eeed5ce01887241b5c7/26c1e10c6bcf3eeed5ce01887241b5c7.png)

<p align="center">（图3）</p>
        `,
      },
      {
        id: "004007",
        title: "得理法搜如何付费使用？",
        content: `
得理法搜对于注册用户可以免费进行类案检索，但查看类案详情或法规详情时，需要付费才可以完整查看，目前支持1年、连续包月、1个月三种购买方式，用户在Web、App、小程序端均可从“我的”->“立即续费”进行付费购买。
        `,
      },
      {
        id: "004008",
        title: "如何要求得理打码案件中的实名信息？",
        content: `
得理法搜中的裁判文书为最高院裁判文书网中公开对应文件，如发现文书中对于当事人名称和地址有需要打码或隐藏时，请添加得理科技企业微信客户进行反馈，我们将尽快为您处理。
        `,
      },
    ],
  },
  {
    id: "005",
    title: "得理律助",
    children: [
      {
        id: "005001",
        title: "谁适合使用得理律助？",
        content: `
得理律助是专为律师打造的智能助手，分为个人版、团队版和机构版三个版本，分别适用于个人律师、团队和律所机构使用。

个人律师可使用常用的客户、合同、项目、任务、法搜、小理智能体、小理AI等功能外，也可以通过认证成为得理律助的入驻律师，获取从小理AI进行法律咨询的客户案源，拓展其案源渠道。

团队版和机构版都适合多人协同的组织使用，机构版更适合流程化管理的律所使用。
        `,
      },
      {
        id: "005003",
        title: "得理律助有哪几种产品形态？",
        content: `
得理律助有Web版和App版两种形态。

Web版URL:https://dls.delilegal.com

App版下载：应用市场搜“得理律助”或手机扫码下载

<p align="left"><img src="https://delicdn.delilegal.com/dls/6d990fe0bb8f3fdb9f401781b81b06c5/6d990fe0bb8f3fdb9f401781b81b06c5.png" alt="image" style="zoom: 33%;" /></p>
        `,
      },
      {
        id: "005004",
        title: "得理律助的不同版本功能有何差异？",
        content: `
从下图可以对比看出不同版本之前的功能差异：

![image](https://delicdn.delilegal.com/dls/8ac2562e7dae605cd1da4febe2364090/8ac2562e7dae605cd1da4febe2364090.png)
        `,
      },
      {
        id: "005005",
        title: "得理律助的用户可以使用得理法搜的所有功能吗？",
        content: `
得理律助内嵌了得理法搜的全部功能，购买得理律助的用户也可用相同的账号单独登入得理法搜（https://data.delilegal.com）进行使用。
        `,
      },
      {
        id: "005006",
        title: "购买得理法搜的用户如何升级成为得理律助用户？",
        content: `
在得理法搜付费后又希望升级到得理律助的用户，支付完对应费用后得理法搜剩余的有效天数会折算到得理律助中。
        `,
      },
      {
        id: "005007",
        title: "邀请成员加入得理律助时显示失败怎么办？",
        content: `
１、提示已失效：邀请链接有效时间为24小时，被邀请成员打开链接提示已失效，联系团队／律所管理员重新生成邀请链接即可。

２、提示席位已满：联系团队／律所管理员购买新的席位，重新生成邀请链接即可。
        `,
      },
      {
        id: "005008",
        title: "团队组织如何切换？",
        content: `
得理律助支持同一用户可以隶属于多个个人、团队或机构，登录成功后，在左上角可进行组织切换，可在个人、所属团队和所属机构之前自由切换，并可创建新的团队和机构。
        `,
      },
      {
        id: "005009",
        title: "开始使用前需要进行怎样的初始化工作？",
        content: `
系统管理员在正式使用前应进行以下初始化设置：

1.  流程审批，设置各个环节的审批人或待办接收人

2.  文件编号，设置合同、盖章的业务流水号规则，包含动态的年份、流水号及文件类型等。如“（2023）深律诉字第0001号”，可以通过“（{年份}）深律诉字第{合同编号}号”来实现。

3.  历史合同数据导入，联系得理企微客服，咨询数据导入（包括历史的合同信息、项目及文件信息）
        `,
      },
      {
        id: "005010",
        title: "个人版已盖章合同和合同创建的区别？",
        content: `
已盖章合同指上线得理律助系统之前的已经盖章的生效中的合同历史数据。合同创建指起草一个合同草稿。
        `,
      },
      {
        id: "005011",
        title: "个人版合同管理与机构版有何差异？",
        content: `
个人版合同管理没有流程驱动，仅上传已盖章合同即视为生效并可管理其履约过程，且无利冲、开票、审批等流程环节。
        `,
      },
      {
        id: "005012",
        title: "律师如何通过得理律助获取案源？",
        content: `
可以通过两个方式在得理律助获取案源，第一个方式是法讯中的商机版块，得理科技每天会从全国各地的招投标信息中采集和梳理法律服务类的招标信息供参考。第二个方式是得理律助首页工作台中的案源版块，可以实时显示小理AI平台用户发起的法律咨询问题，律师可通过抢单回复，以获取与客户沟通的机会。（需注意的是只有通过认证入驻得理律助的律师才可以查看案源）。
        `,
      },
      {
        id: "005013",
        title: "律师如何进行认证以便查看案源？",
        content: `
得理律助中的案源只有认证过的律师才可以查看，可以在"工作台"->"案源"处的“消息”->“律师认证”，完善律师的详细信息，得理后台审核通过后，即可查看案源。
        `,
      },
      {
        id: "005014",
        title: "如何为他人创建日程？",
        content: `
为他人创建日程的场景有助理为主办律师创建待办任务，或律所合伙人给下属员工指派任务，也可用于人力资源给面试者创建面试任务等。

通过“新建任务”->”项目任务“->指定负责人的形式可以为其它创建任务及日程。创建的任务会在"工作台"->"重要提醒"处进行提示。
        `,
      },
      {
        id: "005015",
        title: "个人任务、合同任务、项目任务分别有什么差异？",
        content: `
创建任务时，如果选择是“项目任务”，且选择的项目有关联合同，则该任务的计时也会同步到该合同中。在按合同进行计时统计时，该任务所有的计时会纳入该合同。
        `,
      },
      {
        id: "005016",
        title: "团队版如何管理团队成员？",
        content: `
团队版的管理员（通常为创建该团队的用户），可以通过“管理”->“成员管理”，添加成员（生成邀请链接发给团队成员，由其自主注册加入团队）。也可以点击成员“…”在弹出菜单中“删除该成员”的方式移除成员，以便在人员变动的情况下管理有效席位。
        `,
      },
      {
        id: "005017",
        title: "购买团队版后如何进行席位的扩容？",
        content: `
随着团队的人数增多，若原有席位数不够，管理员可以点击“购买席位”可进行席位扩容。
        `,
      },
      {
        id: "005018",
        title: "团队成员可以看到其它成员的日程信息吗？",
        content: `
管理员可以通过开关配置日程权限。日程权限默认是个人查看自已的日程，但可以通过“管理”->“应用设置”，指定机构所有人可查看选项，团队成员可以查看所有其它人的日程信息。
        `,
      },
      {
        id: "005019",
        title: "团队成员可以查看其它成员的日程信息吗？",
        content: `
管理员可以通过开关配置日程权限。日程权限默认是个人查看自已的日程，但可以通过“管理”->“应用设置”，指定机构所有人可查看选项，团队成员可以查看所有其它人的日程信息。
        `,
      },
      {
        id: "005020",
        title: "签约客户和线索客户的区别？",
        content: `
签约客户顾名思义是有签过正式合同的客户，而线索客户只是一个商机，需要进一步跟进。团队和机构的成员都可以添加线索客户，线索客户的信息是公开的，全员都可以看到和跟进。
        `,
      },
      {
        id: "005021",
        title: "线索客户如何转为签约客户？",
        content: `
线索客户在线下跟进明确要签合同时，无需新建客户，可以将线索客户转为签约客户：线索客户列表->客户状态修改为签约客户，在弹出的客户信息处完善保存，即可转为签约客户。
        `,
      },
      {
        id: "005022",
        title: "如何更好的团队协同？",
        content: `
团队协同包括：协同维护客户、协同处理流程事务、协同处理项目任务、日程协同等。

协同维护客户：客户从线索客户开始，每一次客户的跟进都可以填写跟进记录，以方便后续跟进人员了解对客户的完整服务链路。不论内部人员如何变动，服务轨迹始终留痕。这个工作是管理上的要求，需要律所机构或团队管理者对成员提出要求。

协同处理流程事务：合同全流程、盖章流程、开票流程是律所机构最常用的流程，机构版的流程可以依据组织架构对各个岗位的人员进行设置，以便流程自动将任务推送到待办的接收人处，真正实现闭环的管理，避免人为的工作遗漏造成的低效。

协同处理项目任务：通过项目式的管理，项目成员任务可以有效的组织和进度跟进，项目中的文档可以有效的协同在线编辑，文件动态项目成员可见。通过项目的协同，即便项目跨度时间长，项目成员人员交替，其管理过程的知识的沉淀始终在系统里。

协同日程任务：日程任务可以自已给自已增加（个人任务），也可以给其它人增加（项目任务），可用于上级与下级、同级、下级与上级之间的任务协同管理。
        `
      },
      {
        id: "005023",
        title: "机构版如何管理机构成员？",
        content: `
机构版有两种方式管理组织架构及成员：自主管理组织架构方式和基于钉钉的组织架构管理。可依据日常办公需要进行对应的管理。

自主管理组织架构方式：适用于以微信作为主要沟通交流平台的机构或团队。管理员新建机构或团队后，进入“管理”->“成员与部门”进行邀请和管理。

![image](https://delicdn.delilegal.com/dls/2f0c01672bd14aabaed6d978801e9e59/2f0c01672bd14aabaed6d978801e9e59.png)

基于钉钉的管理方式：基于钉钉的组织架构管理好处是，钉钉中在律所中新增的成员会由系统自动定时同步（凌晨一点）。适用于律所线下管理以钉钉为主，这样可和钉钉现有的业务办公进行有效的结合。

钉钉企业管理员用钉钉扫码开通“DLS律师数字化平台”应用，一旦开通应用，企业里的所有成员就可以使用钉钉扫码登录：

<p align="center">
<img src="https://delicdn.delilegal.com/dls/457bc9155b3357e509bc76fae7806154/457bc9155b3357e509bc76fae7806154.png" alt="image" style="zoom: 33%;" />
</p>
        `
      },
      {
        id: "005024",
        title: "如何管理角色和权限？",
        content: `
得理律助角色与权限主要分为4类：

1.  超级管理员 通常为律所主任、高级合伙人或高层领导，拥有最高权限，可以进行系统设置，并查看全部业务数据。

2.  普通管理员 通常为行政人力、秘书助理、IT技术人员，拥有系统设置权限，可设置流程、成员与部门等。

3.  业务主办 通常为各业务合伙人，拥有查看指定部门的全部业务数据权限。

4.  协办人员 通常为各业务中心的法务秘书或者业务办理者，拥有查看指定部门的合同数据权限以便开展归档、盖章、开票等事务。
        `
      },
      {
        id: "005025",
        title: "成员离职了工作如何交接？",
        content: `
得理律助针对成员离职或调岗的情况，可以将该成员发起的合同、盖章、开票等历史流程或审批中的流程中数据移交给指定的其他人。如果该成员还涉及在审批流中的环节待办人员，还应进入流程管理进行对应的设置。
        `
      },
      {
        id: "005026",
        title: "如何支付购买？",
        content: `
个人版可直接付费购买，团队或机构版的按使用人数进行席位购买，单个席位价格低于个人版，按照席位数阶梯价格不一样，详情咨询得理科技企业微信客服。
        `
      },
      {
        id: "005027",
        title: "合同流程的完整生命周期管理是怎样的？",
        content: `
得理律助使用全流程闭环管理的方式进行合同的管理，合同的全流程可依据律所职务的权责定制化设置各环节的申批人，流程由工作流引擎驱动，自动流转到各个环节。

![image](https://delicdn.delilegal.com/dls/3bfc48a2cc3bd92fea44070b72447d4f/3bfc48a2cc3bd92fea44070b72447d4f.png)
        `
      },
      {
        id: "005028",
        title: "合同如何作废？",
        content: `
合同作废操作可以合同正在审批中时，由审批人打回，或当合同在履约中时，由主办律师进行编辑，并设置合同为“已作废”状态。
        `
      },
      {
        id: "005029",
        title: "机构版已盖章合同和合同创建的区别？",
        content: `
已盖章合同指律所在上线得理律助系统之前的历史数据或律师转所时所带来的已经盖章的生效中的合同，因此无需再走利冲审查等合同的创建流程，直接上传就变为生效状态。合同创建也分为两类，一种是从无到有起草，一种是已经有草稿合同的模板（或第三方的合同），依据实际情况进行创建合同，并需走利冲审查等一系列流程。
        `
      },
      {
        id: "005030",
        title: "有几种发起合同创建的流程方式？",
        content: `
发起合同创建流程分两种情况：一种情况是从合同创建，起草合同后引入利冲审查。另一种情况是先发起利冲审查，审查通过无利冲后再进行合同创建。
        `
      },
      {
        id: "005031",
        title: "利冲审查后是否一定紧跟创建合同步骤？",
        content: `
不一定，比如在客户询价或录入客户潜在客户资料前，先仅仅进行利冲审查预查询，而不创建合同，如无利冲再和客户沟通确定签约后再进行合同创建。
        `
      },
      {
        id: "005032",
        title: "如何使用订卷模板？",
        content: `
合同履约结束时，通常要进行订卷操作，即按照一定的格式打印出订卷的目录或卷宗的边框封条，得理律助支持从订卷模板生成要打印的订卷文件，避免了手动再抄写合同编号、客户信息等操作。

“履约中”的合同，由主办律师在该合同详情页点击“编辑合同”，在合同附件处点击“从模板中生成”选取对应类型的订卷模板，打开生成的订卷附件，直接打印即可，也可以编辑后再打印。
        `
      },
      {
        id: "005033",
        title: "如何补充上传合同的附件？",
        content: `
在合同履约过程中有些补充协议或其它相关文件可以补充上传。“履约中”的合同，由主办律师在该合同详情页点击“编辑合同”，在合同附件处点击“上传附件”。
        `
      },
      {
        id: "005034",
        title: "律所主任如何通过得理律助了解律所实时数据情况？",
        content: `
为了方便律所主任了解律所的合同及客户服务情况，可通过“统计”功能查看律所实时数据统计情况：包括总览、签约客户Top5、客户数量趋势、合同金额趋势、服务时长统计、签约客户统计、客户分布情况等图表化的指标。
        `
      },
    ],
  },
  {
    id: "006",
    title: "智能名片+知识库帮助文档",
    children: [
      {
        id: "006001",
        title: "概览",
        content: `
在数字化转型浪潮中，传统的纸质名片正在被新一代的智能名片所取代。对于法律行业而言，智能名片不仅仅是联系方式的载体，更成为了展示专业能力、提供即时服务、精准获客的综合性数字化工具。智能名片通过技术创新，为律师事务所和执业律师带来全新的服务模式和商业价值。

<h2>传统名片的局限性与智能名片的突破</h2>

<h3>传统名片的困境</h3>

传统纸质名片受制于物理载体的限制，只能承载基础的联系信息，如姓名、职务、电话、邮箱等。对于律师这样需要展示丰富专业背景的职业而言，传统名片显得格外局促：

<span style="display: inline-block;text-indent:20px;">● 信息容量有限：无法展示教育背景、执业经历、专业领域、成功案例等关键信息</span>

<span style="display: inline-block;text-indent:20px;">● 更新成本高：信息变更需要重新印刷，成本高且时效性差</span>

<span style="display: inline-block;text-indent:20px;">● 传播效率低：依赖面对面交换，传播范围受限</span>

<span style="display: inline-block;text-indent:20px;">● 互动性缺失：缺乏即时沟通和深度交流的可能</span>

<h2>智能名片的技术优势</h2>

智能名片基于移动互联网和云计算技术，突破了传统名片的物理限制，实现了信息展示的立体化和互动化：

<span style="display: inline-block;text-indent:20px;">● 多维信息展示：通过富媒体内容，智能名片可以集成视频介绍、案例展示、资质证书、客户评价等多元化信息，全方位展现律师的</span>
<span style="display: inline-block;text-indent:32px;">职业能力和专业水准。</span>

<span style="display: inline-block;text-indent:20px;">● 实时信息更新：基于云端数据同步技术，律师可以随时更新个人信息、最新案例、法律观点等内容，确保客户获取的信息始终是最</span>
<span style="display: inline-block;text-indent:32px;">新的。</span>

<span style="display: inline-block;text-indent:20px;">● 无接触式传播：通过二维码、链接分享等方式，实现跨时空的信息传递，大幅提升传播效率。</span>

<span style="display: inline-block;text-indent:20px;">● 7×24小时智能客服：结合自定义的知识库和大语言模型技术，智能名片可以内置智能问答系统，为客户提供全天候的法律咨询服</span>
<span style="display: inline-block;text-indent:32px;">务。这一功能的技术实现包括：</span>

<span style="display: inline-block;text-indent:20px;">● 知识库：将律师的专业知识、案例经验、法律条文等结构化为知识库，为智能问答提供可靠的数据基础。</span>
        `,
      },
      {
        id: "006002",
        title: "智能名片创建",
        content:`
在微信小程序“得理法搜”，依次点击“我的”-“我的名片”。

![image](https://delicdn.delilegal.com/dls/db52d32abb7982c2c1f0da8904429bb5/db52d32abb7982c2c1f0da8904429bb5.png)

点击编辑名片：完善律师的个人详细信息，包括：基本信息、个人简介、律所简介、教育背景、荣誉头衔等，全面展示律师的个人形象。

提示：

1. 律师勾选打开开关“律师认证-获取案源支持”时，填写执业证号并上传执业证照片，平台将在小理 AI、深i企智能法律的“问律师”等多个渠道向用户推荐律师，为律师引流。

2. 可以通过 AI 智能生成或优化个人信息、律所简介。

3. 可以通过 AI 智能美化头像。
        `
      },
      {
        id: "006003",
        title: "知识库创建",
        content: `
智能名片的知识库支持两种类型：1.腾讯云智能体应用，2.得理律助知识库。

已有“得理律助”机构版账户的用户建议使用“得理律助知识库”管理知识和挂载知识库到智能名片上，否则请使用“腾讯云智能体应用”管理知识和大模型。

<h2>1.创建腾讯云智能体应用</h2>

网页上输入：<a style="color:#4493f8" href="https://cloud.tencent.com/product/tcadp?Is=sdk-topnav">https://cloud.tencent.com/product/tcadp?Is=sdk-topnav</a>  进入智能体开发平台，点击“产品体验”：

![image](https://delicdn.delilegal.com/dls/9383efd3a6782eeee7839bd061a18edd/9383efd3a6782eeee7839bd061a18edd.png)

<h3>注册和登录</h3>

浏览器地址栏中输入：<a style="color:#4493f8" href="https://cloud.tencent.com/product/tcadp">https://cloud.tencent.com/product/tcadp</a> ，点击“产品体验”，微信扫码注册登录到开发平台首页，并新建一个标准应用：

![image](https://delicdn.delilegal.com/dls/48f7b37d7141f1eea0540b5ae1fd73c1/48f7b37d7141f1eea0540b5ae1fd73c1.png)

<h3>上传知识</h3>

点击查看应用并切换到“知识管理”，导入一个或多个本地文件，也可以导入已发表的公众号文章网页：

![image](https://delicdn.delilegal.com/dls/95222e9055668fbcf71ffad9df07c444/95222e9055668fbcf71ffad9df07c444.png)

<h3>发布应用</h3>

点击右上角发布按钮，发布完成后即可从应用发布-服务状态中复制AppKey这个重要的密钥来调用知识库应用了：

![image](https://delicdn.delilegal.com/dls/e916416ac10c145eec66442eeaa79872/e916416ac10c145eec66442eeaa79872.png)

<h2>2.律助知识库管理</h2>

<h3>知识库管理</h3>

浏览器地址栏中输入：<a style="color:#4493f8" href="https://dls.delilegal.com ">https://dls.delilegal.com </a> 进入得理律助，切换到机构版，在左侧菜单栏选择“知识库”，进入知识库查看和管理页：

![image](https://delicdn.delilegal.com/dls/62e41a96c0046e1a507f9c25a5aafc83/62e41a96c0046e1a507f9c25a5aafc83.png)

<h3>知识发布</h3>

点击右上角“发布知识”：

![image](https://delicdn.delilegal.com/dls/67f88e4653d79f69515619ca08556096/67f88e4653d79f69515619ca08556096.png)

AppKey的生成：（如下图示）点击知识库首页右上角”我的发布”，点击左侧菜单“API管理”，如果没有显示
AppKey则点击“重新生成”，生成一个新的AppKey，如果已经有AppKey存在，则点击“复制”到剪贴板再发送到手机端，在“得理法搜”小程序端 -我的名片完成AppKey 的设置并挂载律助知识库。（说明：AppKey是用于用户权限鉴别的重要凭据，请不要泄露给第三人，可以不定期“重新生成”以使原来的 AppKey 失效来加强安全性）
![image](https://delicdn.delilegal.com/dls/997c18c07c1afb829b8068baa4556918/997c18c07c1afb829b8068baa4556918.png)
`
      },
      {
        id: "006004",
        title: "智能名片挂载知识库",
        content: `
在第二步创建名片中的“编辑名片”步骤过程中，勾选打开知识库开关，允许挂载自定义知识库，智能聊天时优先基于知识库回答，填写上个步骤中获取的appKey：

![image](https://delicdn.delilegal.com/dls/6d2ed7d91a96f48dce16a9e5d0208c2c/6d2ed7d91a96f48dce16a9e5d0208c2c.png)

可以对公开的知识库设置权限，比如有些个人机密信息的知识库可以选择不公开：

![image](https://delicdn.delilegal.com/dls/1686a15342895fa5b15ebc5063b0ee39/1686a15342895fa5b15ebc5063b0ee39.png)
`
      },
      {
        id: "006005",
        title: "分享名片",
        content: `
点击第二个步骤中我的名片信息上的“分享名片”按钮，发送到微信聊天、朋友圈等。

![image](https://delicdn.delilegal.com/dls/7a8c2423c5cf4372c91f41318e408568/7a8c2423c5cf4372c91f41318e408568.png)
`
      },
      {
        id: "006006",
        title: "客户咨询使用知识库回答",
        content: `
在律师忙时，可以将智能名片发给客户，向客户提供 7*24 小时的智能数字分身服务，减少了律师回答问题的工作量：

![image](https://delicdn.delilegal.com/dls/f2830461aaad783f2c1dd58a100b552a/f2830461aaad783f2c1dd58a100b552a.png)
`
      },
      {
        id: "006007",
        title: "律师查看运营数据",
        content: `
律师可以从我的名片-“智聊”中查看客户咨询的问题及回答，并识别是否存在潜在案源机会。也可以从“咨询”列表中查看客户发起的一对一人工咨询，并进行线上的沟通回复：

![image](https://delicdn.delilegal.com/dls/b6eeff8cc1944287db124e3d1aab06db/b6eeff8cc1944287db124e3d1aab06db.png)
`
      }
    ]
    }
];
